import qualitiesJson from "../../data/influencerMarketingQualities.json";

export default function Section3() {
  const qualitiesData = qualitiesJson;

  return (
    <div className="Section3">
      <div className="w-[90%] my-[24px] md:my-0 md:w-[61%] mx-auto text-center">
        <h2 className="text-[24px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#151515] mt-[40px]">
          Why Choose Mean3 for Influencer Marketing
        </h2>
      </div>

      <div className="flex p-[2%_0%_1%_0%] justify-center gap-y-[19px] md:gap-y-[30px] gap-x-[2%] w-[85%] xs:w-full md:w-[85%] mx-auto flex-wrap">
        {qualitiesData.map(({ imgUrl, title, text }, index) => {
          return (
            <div
              key={title + index}
              className="bg-[#f5f5f5] text-[#373737] w-full xs:w-[45%] min-[1151px]:w-[35%] p-[10%] xs:p-[4%] md:p-[3%]"
            >
              <img src={imgUrl}></img>

              <h3 className="text-[20px] xl:text-[25px] font-bold leading-[24px] md:leading-[30px] pb-[4%] my-[0.67em]">
                {title}
              </h3>

              <p className="text-[12px] md:text-[14px] mb-5 font-open">{text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
